module.exports = __webpack_public_path__ + "img/CompScope_Mag_1_Focus_1.2421efed.png";